import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  TemplateRef,
} from "@angular/core";
import { Router } from "@angular/router";
import { State, process, GroupResult } from "@progress/kendo-data-query";
import * as $ from "jquery";
import { environment } from "@env/environment";
import { LocalStorageService } from "@app/shared/services/local-storage/local-storage.service";
import { FormBuilder } from "@angular/forms";
import { DropDownFilterSettings } from "@progress/kendo-angular-dropdowns";
import { startWith, map } from "rxjs/operators";
import { GlobalService } from "@app/shared/services/global/global.service";
import { CompanyService } from "@app/modules/company/services/company.service";
// import { LeadsService } from "@app/modules/leads/services/leads.service";
import { LayoutService } from "../../services/layout.service";
import { BsModalService } from "ngx-bootstrap";
import { ToastrMessageService } from "@app/shared/services/toastr-message/toastr-message.service";

export interface StateGroup {
  letter: string;
  names: string[];
}

export const _filter = (opt, value: string): string[] => {
  const filterValue = value.toLowerCase();
  return opt.filter((item) => item.name.toLowerCase().includes(filterValue));
};

@Component({
  selector: "crm-nav-bar",
  templateUrl: "./nav-bar.component.html",
  styleUrls: ["./nav-bar.component.scss"],
})
export class NavBarComponent implements OnInit {
  defaultImagePath = environment.defaultImagePath;
  //@ViewChild("modalRef", { static: true }) modalRef: any;
  @ViewChild("departmentDetailsRef", { static: true })
  departmentDetailsRef: TemplateRef<any>;

  private groupedData: GroupResult[];
  type_id: any;
  organization: any;
  public companyList = [];
  private cList = [];
  private lList = [];
  public leadsList = [];
  organization_id: any = null;
  stateGroups;
  stateForm = this.fb.group({
    query: "",
  });
  public state: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: "and",
      filters: [],
    },
  };
  userInfo: any;
  currentUserId: number;
  imageUrl: any;
  userName: any;
  organizationName: string;
  typeName: string;

  limit = "5";
  page = "1";
  sortno = "1";
  sortnane = "";
  params = {
    limit: this.limit,
    page: this.page,
    sortno: this.sortno,
    sortnane: this.sortnane,
    client_company_id: 1,
    search: {
      company_name: "",
      company_contact: "",
      company_contact_mob: "",
      company_phone: "",
      company_email: "",
      company_website: "",
      company_country_id: "",
      company_state: "",
      company_city: "",
      company_address1: "",
      company_address2: "",
      company_address3: "",
      company_address4: "",
      company_zip: "",
      company_postal_code: "",
    },
  };
  public filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: "contains",
  };
  leadparams = {
    limit: this.limit,
    page: this.page,
    sortno: this.sortno,
    sortnane: this.sortnane,
    client_company_id: 1,
    search: {
      title: "",
      leadSource: "",
      description: "",
    },
  };
  public gridView: any;
  showDropDown = true;

  constructor(
    private router: Router,
    private companyService: CompanyService,
    private localStorageService: LocalStorageService,
    // private leadsService: LeadsService,
    private fb: FormBuilder,
    private _globalService: GlobalService,
    private cdr: ChangeDetectorRef,
    private _LayoutService: LayoutService,
    private modalService: BsModalService,
    private toastrMessage: ToastrMessageService,
  ) {
    this.initForm();
  }

  initForm() {
    console.log("search");
    return (this.stateForm = this.fb.group({
      query: [""],
    }));
  }

  stateGroupOptions;

  private _filterGroup(value: string) {
    console.log("filtered:", value);
    if (value) {
      console.log("inside:", value);
      return this.gridView
        .map((group) => ({
          category: group.category,
          field: _filter(group.field, value),
        }))
        .filter((group) => group.field.length > 0);
    }

    console.log("returned value:", this.gridView);
    return this.gridView;
  }

  ngOnInit() {
    const userStr = this.localStorageService.getLocalStorageItem("response");
    this.type_id = userStr.data.type_id;
    this.organization_id = userStr.data.organization_id;

    const d = JSON.parse(this.localStorageService.getLocalStorageItem("data"));
    console.log(" d :", d, d.type_id);
    this.stateGroupOptions = this.stateForm.get("query").valueChanges.pipe(
      startWith(""),
      map((value) => this._filterGroup(value || "")),
    );

    console.log("recived search value:", this.stateGroupOptions);
    this.getUserInfo();
    this.getCompany(this.params);
    this.getLeads(this.leadparams);
    this.loadOrganization(d.type_id);
    setTimeout(() => {
     // this.reminderSet();
    }, 2000);

    // this.companyService.getSelectedCompanyById().subscribe((response) => {
    //   console.log(response);
    // })
  }

  navigateToDashboard() {
    this.router.navigate(["client/dashboard"]);
    this.router.navigate(["client/dashboard"]);
  }
  goToChangePassword() {
    this.router.navigate(["/change-password"]);
  }

  getUserInfo() {
    const userStr = this.localStorageService.getLocalStorageItem("response");
    this.typeName = userStr.data.type_name;
    this.userName = userStr.data.user.username;
    if (userStr.data.type_id === 1) {
      this.organizationName = userStr.data.type_name;
    } else if (userStr.data.type_id === 3) {
      this.organizationName = userStr.data.userData.company_name;
    } else {
      this.organizationName = userStr.data.organization_name;
    }
  }

  logOut(): void {}

  goToProfile() {
    console.log("i pr");
    this.router.navigate(["/profile/"]);
  }

  selectValue(value) {
    this.stateForm.patchValue({ search: value });
    this.showDropDown = false;
  }

  closeDropDown() {
    this.showDropDown = !this.showDropDown;
  }

  openDropDown() {
    this.showDropDown = false;
  }

  getSearchValue() {
    return this.stateForm.value.search;
  }

  getCompany(body): void {
    const payload = { page: 1, limit: 200 };
    this.companyService.getCompanyList(payload).subscribe(
      (response) => {
        console.log("company response:", response);
        this.companyList = response.data;
        for (let a of this.companyList) {
          this.cList = [
            ...this.cList,
            { name: a.company_name, id: a.company_id },
          ];
        }
        this.gridView = [
          ...(this.gridView || []),
          { category: "Company", field: this.cList },
        ];
      },
      (error) => {
        this.gridView = [];
      },
    );
  }

  navigateToCompanyDetail(company: any): void {
    console.log("company", company);
    this.router.navigate(["/company/view", company]);
  }

  navigateToLeads() {
    this.router.navigate(["/leads"]);
  }

  getLeads(body): void {
    // this.leadsService.getSearchLeadsList(body).subscribe(
    //   (response) => {
    //     if (response.status) {
    //       this.leadsList = response.data;
    //       for (let a of this.leadsList) {
    //         this.lList = [...this.lList, { name: a.title, id: a.lead_id }];
    //       }
    //       this.gridView = [
    //         ...(this.gridView || []),
    //         { category: "Leads", field: this.lList },
    //       ];
    //     } else {
    //       this.gridView = [];
    //     }
    //   },
    //   (error) => { }
    // );
  }

  handleFilter(value) {
    console.log(value);
    this.gridView = this.gridView.filter(
      (s) =>
        (s.company_name &&
          s.company_name.toLowerCase().indexOf(value.toLowerCase()) !== -1) ||
        (s.title && s.title.toLowerCase().indexOf(value.toLowerCase()) !== -1),
    );
  }

  myListParem: any;
  myListParemLen: 0;
  private searchTimeout: any;
  viewVisibility: boolean = false;
  newData: Array<any> = [];
  arrayList: any;
  searchList: any;
  searchQuery: any = "";

  // Modified globalSearchbar for debouncing
  globalSearchbar(event: any) {
    const organization_id = 1;
    this.viewVisibility = true;
    const q1 =
      event && event.target && event.target.value
        ? event.target.value.trim()
        : "";

    console.log("q1:", q1);
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    if (!q1 || q1 === "") {
      this.searchList = { companies: [], leads: [] }; // Clear results if query is empty
      this.cdr.detectChanges();
      return;
    }

    this.searchTimeout = setTimeout(() => {
      // const searchBody = { query: q1 };
      const searchBody = q1;
      console.log("searchBody:", searchBody);
      this._globalService
        .globalSearchService(searchBody, organization_id)
        .subscribe(
          (res) => {
            this.searchList = res.data ? res.data : [];
            this._globalService.setGlobalSearchResults(this.searchList);
            console.log("global search res:", res);
            this.cdr.detectChanges();
          },
          (error) => {
            this.searchList = { companies: [], leads: [] };
            this._globalService.clearGlobalSearchResults();
          },
        );
    }, 500); // 0.5 second debounce
  }

  selectRecommendation(selectRecommendationData: any) {
    this.viewVisibility = false;
    console.log("global selectRecommendationData:", selectRecommendationData);

    this.searchQuery =
      selectRecommendationData && selectRecommendationData.label
        ? selectRecommendationData.label
        : "";

    if (selectRecommendationData.id) {
      if (selectRecommendationData.controller === "LEAD") {
        this.router.navigate(["/lead/view", selectRecommendationData.id]);
      } else if (selectRecommendationData.controller === "CUSTOMER") {
        console.log("global:", selectRecommendationData.controller);
        this.router.navigate([
          "/clientCompany/view",
          selectRecommendationData.id,
        ]);
      } else if (selectRecommendationData.controller === "contact") {
        if (selectRecommendationData.type === "CUSTOMER") {
          console.log("global:", selectRecommendationData.controller);
          this.router.navigate(
            ["/clientCompany/view", selectRecommendationData.company_id], // route param
            {
              queryParams: {
                tab: "contacts",
                // source: 'global',
                contact_id: selectRecommendationData.id,
                type: selectRecommendationData.type,
              },
            },
          );
        } else if (selectRecommendationData.type === "LEAD") {
          console.log("global:", selectRecommendationData.controller);
          this.router.navigate(
            ["/lead/view", selectRecommendationData.company_id], // route param
            {
              queryParams: {
                tab: "contacts",
                // source: 'global',
                contact_id: selectRecommendationData.id,
                type: selectRecommendationData.type,
              },
            },
          );
        }
      }
    } else {
      console.log("Neither company_id nor lead_id found.");
    }
  }

  // New method for Enter key press
  onEnter() {
    this.viewVisibility = false;
    // Clear any pending debounce timeout to ensure immediate search
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    const q1 = this.searchQuery.trim();
    if (!q1) {
      return; // Do nothing if search query is empty
    }

    const searchBody = { query: q1 };
    this._globalService.globalSearchService(searchBody, 1).subscribe(
      (res) => {
        this.searchList = res && res.data ? res.data : [];
        this._globalService.setGlobalSearchResults(this.searchList);
        console.log("global search on Enter res:", res);
        this.arrayList = this.searchList; // Set arrayList for navigation
        this.router.navigate(["/search/list", 1]); // Navigate to search results page
        this.searchQuery = ""; // Clear search query after navigation
        this.cdr.detectChanges();
      },
      (error) => {
        this.searchList = { companies: [], leads: [] };
        this._globalService.clearGlobalSearchResults();
        this.searchQuery = ""; // Clear search query on error
      },
    );
  }

  //new
  loadOrganization(type_id: any) {
    const orgId = type_id;

    this._LayoutService.getOrganizationById(orgId).subscribe({
      next: (res) => {
        this.organization = res.data;
        console.log("Organization:", this.organization);
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error("API Error:", err);
      },
    });
  }

  //pop up reminder
  reminderList: any = null;
  hide_departmentDetailsRef: any;
  reminderSet() {
    this._LayoutService
      .pollReminders(this.organization_id)
      .subscribe((response) => {
        if (response.success === true || response.success === "true") {
          if (response.data != null && response.data.length > 0) {
            this.reminderList = response.data;
            // Hide previous modal if it exists
            if (this.hide_departmentDetailsRef) {
              this.hide_departmentDetailsRef.hide();
            }
            this.viewModal(this.departmentDetailsRef);
          }
        }
      });
  }

  viewModal(template: TemplateRef<any>) {
    this.hide_departmentDetailsRef = this.modalService.show(template, {
      class: "modal-dialogue-centered modal-md",
      backdrop: "static",
      keyboard: true,
      initialState: {
        reminders: this.reminderList, // 👈 pass array here
      },
    });
  }
  onclose() {
    console.log("hide:", this.hide_departmentDetailsRef);
    this.hide_departmentDetailsRef.hide();
  }
  reminderRead(dataItema: any) {
    const formData = new FormData();
    const call_log_id = dataItema.call_log_id;
    formData.append("call_log_id", call_log_id);
    this._LayoutService
      .callLogMarkReminderDone(this.organization_id, formData)
      .subscribe((response) => {
        if (response.success == true || response.success == "true") {
          this.toastrMessage.showSuccess(
            response.message || "Mark done succesffully",
          );
          this.hide_departmentDetailsRef.hide();
        } else {
          this.toastrMessage.showError(response.message || "error occure!");
        }
      });
  }
}
